import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {Contract} from '../model/Entities/Contract';
import {ContractItem} from '../model/Entities/ContractItem';
import {ProductContractItem} from '../model/Entities/ProductContractItem';
import {ContractItemTransferService} from './contract-item-transfer.service';
import {ContractItemTransfer} from '../model/Entities/ContractItemTransfer';
import {ServiceLocator} from './locator.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ContractItemService extends ApiService<ContractItem> {

    protected apiUrl = 'api/contract-items';  // URL to web api

    private contractItemTransferService: ContractItemTransferService;

    listeners: any[] = [];

    protected getObjectType(): any {
        return ContractItem;
    }

    public subscribeForChanges(component: any): void {
        this.listeners.push(component);
    }

    public unsubscribeForChanges(component: any): void {
        this.listeners.splice(this.listeners.indexOf(component), 1);
    }

    public notifyChanges(): void {
        this.listeners.forEach(l => l.contractItemsChangedFromService());
    }

    public addLostItem(lostItem: any, contractId: number): void {
        this.contractItemTransferService = ServiceLocator.injector.get(ContractItemTransferService)

        let lostCi: ProductContractItem = new ProductContractItem();
        lostCi.setProduct(lostItem.content);
        lostCi.contractId = contractId;
        lostCi.name = 'ZTRÁTA: ' + lostItem.content.name;
        lostCi.count = lostItem.lostCount;
        lostCi.lentCount = lostCi.count;
        lostCi.order = 9990;
        lostCi.lossPrice = lostItem.content.lossPrice;
        lostCi.isLoss = true;

        this.save(lostCi).subscribe((item: ProductContractItem) => {
            let transfer: ContractItemTransfer = new ContractItemTransfer();
            transfer.contractItemId = item.id;
            transfer.count = lostItem.lostCount;

            this.contractItemTransferService.save(transfer).subscribe();
        });
    }

    sortData(contractId: number): Observable<any> {
        return this.sendPost(`${this.apiRoot}/api/contract-items-sort`, {
            contract_id: contractId,
        });
    }
}



// WEBPACK FOOTER //
// /app/src/services/contract-item.service.ts